import stylesMediaText from '@components/media-text/MediaText.module.scss'

import Content from '@components/media-text/components/content/Content'
import Heading from '@components/media-text/components/heading/Heading'
import Video from '@components/media-text/components/video/Video'
import { usePbProps } from '@content/helpers/src/context'

export default function PlaceholderAutoPlayVideo({ onOpenModal }) {
    const { copywriting, campaign }: any = usePbProps()
    const {
        link,
        title,
        description,
        video,
        cta,
        cta_secondary,
        promotion_details
    } = copywriting

    return (
        <>
            <div className={stylesMediaText['media-text__placeholder']}>
                {Video(video)}
            </div>
            <div className={stylesMediaText['media-text__content']}>
                <div>
                    <Heading title={title} />
                </div>
                <div>
                    <Content
                        link={link}
                        onOpenModal={onOpenModal}
                        promotion_details={promotion_details}
                        campaign={campaign}
                        text={description}
                        buttonPrimary={cta}
                        buttonSecondary={cta_secondary}
                    />
                </div>
            </div>
        </>
    )
}
